import withRedux from './withRedux';

export default withRedux;